// extracted by mini-css-extract-plugin
module.exports = {"compulsoryFrameTitleWrapper":"compulsoryFrameLabel__compulsoryFrameTitleWrapper___2UZAp","compulsoryFrameTitle":"compulsoryFrameLabel__compulsoryFrameTitle___tCaAr"};